export enum SubModules {
  LEAVE = 'LEAVE',
  ADVANCE_ON_SALARY = 'ADVANCE_ON_SALARY',
  EXPENSE_ACCOUNT = 'EXPENSE_ACCOUNT',
  RESOURCES = 'RESOURCES',
  SIGNATURE = 'SIGNATURE'
  }